<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">{{ title }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 검색조건 영역 -->
      <div class="search-form">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-col :span="12">
                <el-form-item label="접수일자">
                  <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="1" style="text-align: start;">-</el-col>
              <el-col :span="10">
                <el-form-item label-width="0px">
                  <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="8">
              <el-form-item label="지역/센터">
                <el-select v-model="form.areaAgent" style="width: 45%;">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['areaAgent']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.areaAgentDetail" v-if="form.areaAgent != ''" style="width: 45%;">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['areaAgentDetail']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리기사">
                <el-select v-model="form.agerntUser">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['agerntUser']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 테이블 -->
      <div class="talbe-contain">
        <div class="table-sub-contain"  style="width: 100%;">
          <div class="table-area">
            <div class="table-b">
              <!-- <dhx-grid ref="grid2" v-model="subData" :config="config_child" /> -->
              <ag-grid-vue
                  ref="gridSub"
                  style="width: 100%; height: 78vh; min-height: 25px;"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :columnDefs="columnDefsSub"
                  :defaultColDef="defaultColDefSub"
                  :frameworkComponents="frameworkComponents"
                  :rowData="subData"
                  :gridOptions="gridOptionsSub"
                  :suppressRowClickSelection="false"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "product",
  components: {},
  data() {
    return {
      title: "",
      deleteList: [],
      parentNm: "",
      form: {
        startDt: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
        modelCd : "",
        maker : "",
        modelGroup : "",
        standardModelNm : "",
        modelNm : "",
        asAgentId: "",
        asAgentNm: "",
        areaAgent: "",
        areaAgentDetail: "",
        agerntUser: "",
      },
      defForm: {
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      combos: {
        'areaAgent' : [],             //지역구분
        'areaAgentDetail' : [],             //지역구분
        'agerntUser' : [],        //AS기사
      },
      groupDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      selectId : "",
      makerCombo : [],
      productCombo1 : [],
      productCombo2 : [],
      componentForm : [],
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      this.goOpen();
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;


      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.columnDefsSub = [
        {
          headerName: '구분', children: [
            {headerName: '', field: 'title', width: 50, editable: false},
            {headerName: '', field: 'asStatusNm', width: 50, editable: false},
          ], width: 200, editable: false,
        },
        {
          headerName: '컴퓨터', children: [
            {headerName: '데스크탑', field: 'modelCdQty', width: 50, editable: false},
            {headerName: '노트북', field: 'modelCnQty', width: 50, editable: false},
            {headerName: 'UMPC', field: 'modelCuQty', width: 50, editable: false},
            {headerName: 'CMPC', field: 'modelCcQty', width: 50, editable: false},
            {headerName: '기타', field: 'modelCEtcQty', width: 50, editable: false},
          ], width: 1200, editable: false,
        },
        {
          headerName: '모니터', children: [
            {headerName: 'LCD', field: 'modelMlQty', width: 50, editable: false},
            {headerName: 'CDT', field: 'modelMcQty', width: 50, editable: false},
            {headerName: '기타', field: 'modelMEtcQty', width: 50, editable: false},
          ], width: 1200, editable: false,
        },
        {headerName:'TV', field:'modelTQty', width:100, editable:false},
        {headerName:'냉장고', field:'modelFQty', width:100, editable:false},
        {headerName:'에어컨', field:'modelAQty', width:100, editable:false},
        {headerName:'세탁기', field:'modelWQty', width:100, editable:false},
        {headerName:'공기청정기', field:'modelAirQty', width:100, editable:false},
        {headerName:'의류건조기', field:'modelYQty', width:100, editable:false},
        {headerName:'사운드바', field:'modelSoundBarQty', width:100, editable:false},
        {headerName:'전자레인지', field:'modelMwQty', width:100, editable:false},
        {headerName:'청소기', field:'modelCleanerQty', width:100, editable:false},
        {headerName:'펫드라이어룸', field:'modelPetQty', width:100, editable:false},
        {headerName:'합계', field:'modelQty', width:100, editable:false},
      ];

    },
    goOpen() {

      this.$store.commit('loading')
      let catId = '';
      if(this.form.areaAgent != '' &&this.form.areaAgentDetail != ''){
        catId = this.form.areaAgentDetail;
      }else if(this.form.areaAgent != '' &&this.form.areaAgentDetail == ''){
        catId = this.form.areaAgent;
      }else{
        catId = 0;
      }
      this.$http
          .post("/api/reportMng/spendDetail/list", {
            companyId: this.$store.state.loginInfo.compCd,
            startDt : this.form.startDt,
            endDt : this.form.endDt,
            catId : catId,
            repairId : this.form.agerntUser == '' ? 0 : this.form.agerntUser,
            sortType : '',
            processTime : ""
          })
          .then(response => {
            this.subData = response.data;
          }).finally(() => {
          this.autoSizeAll(this.gridApi);
          this.$store.commit('finish')
      });

    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/reportMng/spendDetail/init`,{
        parentId: this.form.areaAgent,
        parentId2: this.form.areaAgentDetail
      })
          .then(response => {
            this.combos['areaAgent'] = response.data.areaAgent;            //지역구분
            this.combos['areaAgentDetail'] = response.data.areaAgentDetail;//지역구분상세
            this.combos['agerntUser'] = response.data.agerntUser;  //AS기사
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
    },

  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

    this.init();

  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
    this.title = this.$route.name;
  },
  watch: {
    'form.areaAgent'() {
      this.init();
    },
    'form.areaAgentDetail'() {
      this.init();
    },
  }
};

</script>


<style scoped>
.gridbox {
  height: 200px !important;
}
.gridbox .objbox {
  height: 350px !important;
}

.desc-content:after {
  clear: both;
  content: "";
  display: block;
}
.btn-wrap {
  margin-bottom: 20px;
}
.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}
.desc-content .item {
  float: left;
}
.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}
.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}
.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}
.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}
.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}
.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}
.desc-content .item.desc-left {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-center {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-right {
  width: 30%;
}
.search-area input {
  position: relative;
}
.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}
.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}
.search-border .td-s-thumb.search-area > input,
.search-border
.td-s-thumb.search-area
> .ip-box
.search-border
.td-s-thumb.search-area
> button {
  float: left;
}
.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}
.remove_text {
  margin-left: 0;
}
.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
}

.btn-search {
  border-radius: 4px;
  padding: 0 20px;
  font-size: 15px;
  height: 34px;
  font-family: 'NotoM';
  background: #646464;
  color: #fff;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}
</style>